<template>
  <div class="Home">
    <Header></Header>
    <div class="content">
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from "@/components/layout/Header.vue";
import { getContList } from "@/api/index";
export default {
  components: {
    Header
  }
}
</script>

<style lang="scss" scoped>
  .Home {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .content {
    flex: 1;
    width: 100%;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/page/Home.vue